<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{name: 'prescriptions'}">Prescriptions</router-link></li>
        <li class="breadcrumb-item active">New prescription</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <h3 class="page-title">New prescription</h3>
      </div>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Clinic information</h6>
        </div>
      </div>
      <div v-if="Object.keys(record.prescription_info.clinic).length !== 0" class="card-body">
        <div class="row">
          <div class="col">
            <p>{{ record.prescription_info.clinic.name }}</p>
            <p>Ph: {{ record.prescription_info.clinic.phone }}</p>
            <p>Fax: {{ record.prescription_info.clinic.fax }}</p>
            <p>{{ record.prescription_info.clinic.email }}</p>
          </div>
          <div class="col">
            <p>{{ record.prescription_info.clinic.address }}</p>
            <p>{{ record.prescription_info.clinic.state }}</p>
            <p>{{ record.prescription_info.clinic.city }}</p>
            <p>{{ record.prescription_info.clinic.zip }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Doctor information</h6>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary btn-sm" @click="editDoctorInfo()">
            <i class="icon-fa icon-fa-edit" /> Edit
          </button>
        </div>
      </div>
      <div v-if="Object.keys(record.prescription_info.doctor).length !== 0" class="card-body">
        <div class="row">
          <div class="col">
            <p>{{ record.prescription_info.doctor.name }}</p>
          </div>
          <div class="col">
            <p>Lic: {{ record.prescription_info.doctor.lic }}</p>
            <p>DEA No: {{ record.prescription_info.doctor.dea }}</p>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="doctor_info"
        :blocking="true"
        :hide-close-button="true"
        title="Change a doctor"
      >
        <multiselect
          v-model="record.newDoctor"
          :options="profiles"
          :multiple="false"
          track-by="id"
          label="customer"
        />
        <button
          slot="button"
          type="button"
          class="btn btn-primary"
          @click="$refs.doctor_info.close()"
        >Cancel</button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          @click="changeDoctor()"
        >Change</button>
      </sweet-modal>
    </div>
    <div
      v-if="$store.state.permissions.create.prescriptions"
      :class="{ 'text-white bg-danger': $v.record.prescription_info.patient.patient_name.$error && !$v.record.prescription_info.patient.patient_name.required }"
      class="card"
    >
      <div class="card-header">
        <div class="caption">
          <h6>Patient information</h6>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary btn-sm" @click="editPatientInfo()">
            <i class="icon-fa icon-fa-edit" /> Edit
          </button>
        </div>
      </div>
      <div
        v-if="$v.record.prescription_info.patient.patient_name.$error && !$v.record.prescription_info.patient.patient_name.required"
        class="card-body"
      >
        <p>Patient name is required!</p>
      </div>
      <div v-if="Object.keys(record.prescription_info.patient).length !== 0" class="card-body">
        <div class="row">
          <div class="col">
            <p>Patient Name: {{ record.prescription_info.patient.patient_name }}</p>
            <p>Breed: {{ record.prescription_info.patient.breed }}</p>
            <p>Date of Birth: {{ record.prescription_info.patient.date_of_birth }}</p>
            <p>Allergies: {{ record.prescription_info.patient.allergies }}</p>
          </div>
          <div class="col">
            <p>Species: {{ record.prescription_info.patient.species }}</p>
            <p>Weight: {{ record.prescription_info.patient.weight }}</p>
            <p>Sex: {{ record.prescription_info.patient.sex }}</p>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="patient_info"
        :blocking="true"
        :hide-close-button="true"
        title="Change patient info"
        class="text-default"
      >
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Patient Name</label>
              <input
                v-model.trim="new_patient_info.patient_name"
                class="form-control"
                @input="$v.record.prescription_info.patient.patient_name.$touch()"
              >
              <div
                v-if="$v.record.prescription_info.patient.patient_name.$error && !$v.record.prescription_info.patient.patient_name.required"
                class="invalid-feedback"
              >This field is required.</div>
            </div>
            <div class="form-group">
              <label>Breed</label>
              <input v-model.trim="new_patient_info.breed" class="form-control" >
            </div>
            <div class="form-group">
              <label>Date of Birth</label>
              <flat-pickr :config="options" v-model="new_patient_info.date_of_birth" class="form-control" placeholder="Select Date"/>
            </div>
            <div class="form-group">
              <label>Allergies</label>
              <input v-model.trim="new_patient_info.allergies" class="form-control" >
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Species</label>
              <input v-model.trim="new_patient_info.species" class="form-control" >
            </div>
            <div class="form-group">
              <label>Weight</label>
              <input v-model.trim="new_patient_info.weight" class="form-control" >
            </div>
            <div class="form-group">
              <label>Sex</label>
              <select v-model="new_patient_info.sex" name="position" class="form-control">
                <option value="male" >Male</option>
                <option value="female">Female</option>
              </select>
            </div>
          </div>
        </div>
        <button
          slot="button"
          type="button"
          class="btn btn-primary"
          @click="cancelEditPatient()"
        >Cancel</button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          @click="editPatient()"
        >Change</button>
      </sweet-modal>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" :class="{ 'text-white bg-danger': $v.record.prescription_info.prescription.drugs.$error && !$v.record.prescription_info.prescription.drugs.required }" class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Prescription information</h6>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary btn-sm" @click="editPrescriptionInfo()">
            <i class="icon-fa icon-fa-edit" /> Edit
          </button>
        </div>
      </div>
      <div
        v-if="$v.record.prescription_info.prescription.drugs.$error && !$v.record.prescription_info.prescription.drugs.required"
        class="card-body"
      >
        <p>One or more drug(s) required for prescription!</p>
      </div>
      <div v-if="Object.keys(record.prescription_info.prescription).length > 1" class="card-body">
        <div class="row">
          <div class="col">
            <p v-if="record.prescription_variant === 'refill'">Refill No: {{ record.prescription_info.prescription.refill_no }}</p>
            <p v-if="record.prescription_variant === 'new'">Prescription No: {{ record.prescription_info.prescription.prescription_no }}</p>
            <p v-if="record.prescription_variant === 'new'">Prescription Date: {{ record.prescription_info.prescription.prescription_date }}</p>
            <p v-if="record.prescription_variant === 'new'">Directions: {{ record.prescription_info.prescription.directions }}</p>
          </div>
        </div>
        <hr >
        <div v-if="record.prescription_info.prescription.drugs">
          <div
            v-for="(drug, idx) in record.prescription_info.prescription.drugs"
            :key="idx"
            class="row"
          >
            <div v-if="drug.product" class="col">
              <p>{{ drug.product.name }}</p>
            </div>
            <div v-if="drug.form" class="col">
              <p>Form: {{ drug.form.name }}</p>
            </div>
            <div v-if="drug.strength" class="col">
              <p>Strength: {{ drug.strength.name }}</p>
            </div>
            <div v-if="drug.raw_strength" class="col">
              <p>Strength: {{ drug.raw_strength }}</p>
            </div>
            <div v-if="drug.quantity" class="col">
              <p>Quantity: {{ drug.quantity }}</p>
            </div>
            <div v-if="drug.flavor" class="col">
              <p>Flavor: {{ drug.flavor.name }}</p>
            </div>
            <div v-if="drug.cost" class="col">
              <p>Cost: {{ drug.cost }}</p>
            </div>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="prescription_info"
        :blocking="true"
        :hide-close-button="true"
        title="Change prescription info"
        width="90%"
        class="text-default"
      >
        <div class="row">
          <div class="col">
            <h5 class="section-semi-title mt-4">Prescription type</h5>
            <div class="custom-control custom-radio">
              <input
                id="type_new"
                v-model="record.prescription_variant"
                type="radio"
                value="new"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="type_new">New</label>
            </div>
            <div class="custom-control custom-radio mb-3">
              <input
                id="type_refill"
                v-model="record.prescription_variant"
                type="radio"
                value="refill"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="type_refill">Refill</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Prescription No</label>
              <input v-model.trim="record.prescription_info.prescription.prescription_no" class="form-control" >
            </div>
            <div class="form-group">
              <label>Prescription Date</label>
              <flat-pickr :config="options" v-model="record.prescription_info.prescription.prescription_date" class="form-control" placeholder="Select Date"/>
            </div>
            <div class="form-group">
              <label>Notes</label>
              <input v-model.trim="record.prescription_info.prescription.directions" class="form-control" >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <table class="table">
              <thead>
                <tr>
                  <td>Drug</td>
                  <td>Form</td>
                  <td>Strength</td>
                  <td>Custom strength</td>
                  <td>Quantity</td>
                  <td>Flavor</td>
                  <td>Cost</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(drug, index) in record.prescription_info.prescription.drugs" :key="index">
                  <td>
                    <div class="input-wrap">
                      <v-autocomplete
                        :component-item="rowItem"
                        :input-attrs="{ class: { 'form-control': true, 'is-invalid': $v.record.prescription_info.prescription.drugs.$each[index].product.$error }, placeholder: 'Drug' }"
                        :items="drugs"
                        v-model="drug.product"
                        :get-label="getLabel"
                        @change="$v.record.prescription_info.prescription.drugs.$each[index].product.$touch()"
                      />
                      <div
                        v-if="$v.record.prescription_info.prescription.drugs.$each[index].product.$error && !$v.record.prescription_info.prescription.drugs.$each[index].product.required"
                        class="invalid-feedback"
                      >This field is required.</div>
                    </div>
                  </td>
                  <td>
                    <v-autocomplete
                      :component-item="rowItem"
                      :input-attrs="{ class: 'form-control', placeholder: 'Form' }"
                      :items="forms"
                      v-model="drug.form"
                      :get-label="getLabel"
                    />
                  </td>
                  <td>
                    <v-autocomplete
                      :component-item="rowItem"
                      :input-attrs="{ class: 'form-control', placeholder: 'Strength' }"
                      :items="strengths"
                      v-model="drug.strength"
                      :get-label="getLabel"
                    />
                  </td>
                  <td>
                    <input
                      class='form-control'
                      placeholder='Custom strength'
                      v-model="drug.raw_strength"
                    />
                  </td>
                  <td>
                    <input
                      class='form-control'
                      placeholder='Quantity'
                      v-model="drug.quantity"
                    />
                  </td>
                  <td>
                    <v-autocomplete
                      :component-item="rowItem"
                      :input-attrs="{ class: 'form-control', placeholder: 'Flavor' }"
                      :items="flavors"
                      v-model="drug.flavor"
                      :get-label="getLabel"
                    />
                  </td>
                  <td>
                    <input
                      v-model.number="drug.cost"
                      placeholder="Empty for auto"
                      class="form-control"
                      type="number"
                    >
                  </td>
                  <td>
                    <i
                      v-tooltip.top-center="'Delete'"
                      v-if="record.prescription_info.prescription.drugs.length !== 1"
                      class="icon-im icon-im-bin delete--link"
                      @click="removeDrug(index)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" class="btn btn-success" @click="addDrug">Add drug</button>
          </div>
        </div>
        <button
          slot="button"
          type="button"
          class="btn btn-primary"
          @click="cancelEditPrescription()"
        >Cancel</button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          @click="editPrescription()"
        >Change</button>
      </sweet-modal>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Shipping and Billing</h6>
        </div>
        <div class="actions">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="editShippingAndBillingInfo()"
          >
            <i class="icon-fa icon-fa-edit" /> Edit
          </button>
        </div>
      </div>
      <div
        v-if="Object.keys(record.prescription_info.shipping_and_billing).length !== 0"
        class="card-body"
      >
        <div class="row">
          <div class="col">
            <p>Bill to: {{ record.prescription_info.shipping_and_billing.bill | capitalize }}</p>
            <p
              v-if="record.prescription_info.shipping_and_billing.billing_name"
            >Billing Name: {{ record.prescription_info.shipping_and_billing.billing_name }}</p>
            <p
              v-if="record.prescription_info.shipping_and_billing.card_number"
            >Billing Card (last 4 digits): {{ record.prescription_info.shipping_and_billing.card_number }}</p>
            <p
              v-if="record.prescription_info.shipping_and_billing.card_expiration"
            >Card exp. date: {{ record.prescription_info.shipping_and_billing.card_expiration }}</p>
          </div>
          <div v-if="record.prescription_info.shipping_and_billing.bill == 'owner'" class="col">
            <p>Billing address</p>
            <p>Address: {{ record.prescription_info.shipping_and_billing.address }}</p>
            <p>State / Province / Region: {{ record.prescription_info.shipping_and_billing.state }}</p>
            <p>City: {{ record.prescription_info.shipping_and_billing.city }}</p>
            <p>Zip / Postal Code: {{ record.prescription_info.shipping_and_billing.zip }}</p>
          </div>
        </div>
        <hr >
        <div class="row">
          <div class="col">
            <p>Ship to: {{ record.prescription_info.shipping_and_billing.ship | capitalize }}</p>
          </div>
          <div v-if="record.prescription_info.shipping_and_billing.ship == 'owner'" class="col">
            <p>Shipping address</p>
            <p>Address: {{ record.prescription_info.shipping_and_billing.address }}</p>
            <p>State / Province / Region: {{ record.prescription_info.shipping_and_billing.state }}</p>
            <p>City: {{ record.prescription_info.shipping_and_billing.city }}</p>
            <p>Zip / Postal Code: {{ record.prescription_info.shipping_and_billing.zip }}</p>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="shipping_billing_info"
        :blocking="true"
        :hide-close-button="true"
        title="Shipping and Billing"
      >
        <div class="row">
          <div class="col">
            <div v-if="new_shipping_billing_info.billing_name" class="form-group">
              <label>Billing Name</label>
              <input v-model.trim="new_shipping_billing_info.billing_name" class="form-control" >
            </div>
            <div v-if="new_shipping_billing_info.card_number" class="form-group">
              <label>Billing Card (last 4 digits)</label>
              <input v-model.trim="new_shipping_billing_info.card_number" class="form-control" >
            </div>
            <div v-if="new_shipping_billing_info.card_expiration" class="form-group">
              <label>Card exp. date</label>
              <input v-model.trim="new_shipping_billing_info.card_expiration" class="form-control" >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="section-semi-title mt-4">Billing</h5>
            <div class="custom-control custom-radio">
              <input
                id="bill_clinic"
                v-model="new_shipping_billing_info.bill"
                type="radio"
                value="clinic"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="bill_clinic">Clinic</label>
            </div>
            <div class="custom-control custom-radio mb-3">
              <input
                id="bill_owner"
                v-model="new_shipping_billing_info.bill"
                type="radio"
                value="owner"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="bill_owner">Owner</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="section-semi-title mt-4">Shipping</h5>
            <div class="custom-control custom-radio">
              <input
                id="ship_clinic"
                v-model="new_shipping_billing_info.ship"
                type="radio"
                value="clinic"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="ship_clinic">Clinic</label>
            </div>
            <div class="custom-control custom-radio mb-3">
              <input
                id="ship_owner"
                v-model="new_shipping_billing_info.ship"
                type="radio"
                value="owner"
                class="custom-control-input"
              >
              <label class="custom-control-label" for="ship_owner">Owner</label>
            </div>
          </div>
        </div>
        <div v-if="new_shipping_billing_info.ship == 'owner'" class="row">
          <div class="col">
            <div class="form-group">
              <label>Address</label>
              <input v-model.trim="new_shipping_billing_info.address" class="form-control" >
            </div>
            <div class="form-group">
              <label>City</label>
              <input v-model.trim="new_shipping_billing_info.city" class="form-control" >
            </div>
            <div class="form-group">
              <label>State</label>
              <input v-model.trim="new_shipping_billing_info.state" class="form-control" >
            </div>
            <div class="form-group">
              <label>Zip</label>
              <input v-mask="getZipMask(new_shipping_billing_info.zip)" v-model.trim="new_shipping_billing_info.zip" class="form-control" >
            </div>
          </div>
        </div>
        <button
          slot="button"
          type="button"
          class="btn btn-primary"
          @click="cancelEditShippingBilling()"
        >Cancel</button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          @click="editShippingBilling()"
        >Change</button>
      </sweet-modal>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" class="card">
      <div class="card-header">
        <div class="caption">
          <h6>Additional information</h6>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-primary btn-sm" @click="editAdditionalInfo()">
            <i class="icon-fa icon-fa-edit" /> Edit
          </button>
        </div>
      </div>
      <div v-if="Object.keys(record.prescription_info.additional).length !== 0" class="card-body">
        <div class="row">
          <div class="col">
            <p>Message: {{ record.prescription_info.additional.message }}</p>
          </div>
        </div>
        <div v-if="record.prescription_info.additional.files" class="row">
          <div class="col">
            <p>Files:</p>
            <p v-for="(file, idx) in record.prescription_info.additional.files" :key="idx">
              <a :href="file.link" target="_blank">{{ file.title }}</a>
            </p>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="additional_info"
        :blocking="true"
        :hide-close-button="true"
        title="Additional info"
      >
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Message</label>
              <textarea v-model.trim="new_additional_info.message" class="form-control"/>
            </div>
          </div>
        </div>
        <button
          slot="button"
          type="button"
          class="btn btn-primary"
          @click="cancelEditAdditional()"
        >Cancel</button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          @click="editAdditional()"
        >Change</button>
      </sweet-modal>
    </div>
    <div v-if="$store.state.permissions.create.prescriptions" class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <button type="button" class="btn btn-success" @click="savePrescription">Save</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card">
      <div class="card-header">
        <h3>You have not permission for do that</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { SweetModal } from 'sweet-modal-vue'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import RowItem from '../../../components/public-forms/RowItem.vue'
import ZipMask from './../../../mixins/ZipMask'

export default {
  name: 'PrescriptionsCreate',
  components: {
    SweetModal,
    Multiselect
  },
  mixins: [ZipMask],
  validations: {
    record: {
      prescription_info: {
        patient: {
          patient_name: {
            required
          }
        },
        prescription: {
          drugs: {
            $each: {
              product: {
                required
              }
            }
          }
        }
      }
    }
  },
  data () {
    return {
      record: {
        prescription_info: {
          clinic: {},
          doctor: {},
          patient: {},
          prescription: {
            drugs: [
              {
                product: undefined,
                forms: [],
                strengths: [],
                pack_sizes: [],
                flavors: []
              }
            ]
          },
          shipping_and_billing: {},
          additional: {}
        }
      },
      profiles: [],
      new_patient_info: {},
      new_shipping_billing_info: {},
      new_additional_info: {},
      rowItem: RowItem,
      drugs: [],
      forms: [],
      strengths: [],
      pack_sizes: [],
      flavors: [],
      options: {
        allowInput: true,
        dateFormat: 'm/d/Y',
        enableTime: false,
        enableSeconds: false
      }
    }
  },
  mounted () {
    let that = this
    axios
      .get('/api/public/drugs-list')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          that.drugs = response.data.drugs
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .get('/api/public/drug-form')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          this.forms = response.data.forms
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .get('/api/public/drug-strength')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          this.strengths = response.data.strengths
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .get('/api/public/drug-pack-size')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          this.pack_sizes = response.data.pack_sizes
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .get('/api/public/drug-flavor')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          this.flavors = response.data.flavors
        } else {
          console.log(response.data.message)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    setStatus (status) {
      this.record.status = status
      this.saveRecord()
    },
    getLabel (item) {
      return (item && item.name) || ''
    },
    savePrescription () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios
          .post('/api/admin/prescriptions/save', { prescription: this.record })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.prescription
              toastr['success']('Record has been saved successfully')
              this.$router.push('/admin/prescriptions')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    editDoctorInfo () {
      axios
        .get('/api/admin/profiles')
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            this.profiles = response.data.profiles
            this.$refs.doctor_info.open()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeDoctor () {
      if (this.record.newDoctor) {
        this.record.prescription_info.clinic = {
          id: this.record.newDoctor.id,
          name: this.record.newDoctor.clinic,
          phone: this.record.newDoctor.phone,
          fax: this.record.newDoctor.fax,
          email: this.record.newDoctor.user.email,
          address: this.record.newDoctor.address,
          state: this.record.newDoctor.state,
          city: this.record.newDoctor.city,
          zip: this.record.newDoctor.zip
        }

        this.record.prescription_info.doctor = {
          name: this.record.newDoctor.doctor,
          lic: this.record.newDoctor.license_no,
          dea: this.record.newDoctor.dea_no
        }
      }
      this.$refs.doctor_info.close()
    },
    editPatientInfo () {
      this.new_patient_info = JSON.parse(
        JSON.stringify(this.record.prescription_info.patient)
      )
      this.$refs.patient_info.open()
    },
    cancelEditPatient () {
      this.new_patient_info = {}
      this.$refs.patient_info.close()
    },
    editPatient () {
      if (Object.keys(this.new_patient_info).length !== 0) {
        this.record.prescription_info.patient = JSON.parse(
          JSON.stringify(this.new_patient_info)
        )
      } else {
        this.new_patient_info = {}
      }
      this.$v.$touch()
      if (!this.$v.record.prescription_info.patient.$invalid) {
        this.$refs.patient_info.close()
      }
    },
    editPrescriptionInfo () {
      this.$refs.prescription_info.open()
    },
    cancelEditPrescription () {
      this.$refs.prescription_info.close()
    },
    addDrug () {
      let drugs = this.record.prescription_info.prescription.drugs
      drugs.push({
        product: undefined,
        forms: [],
        strengths: [],
        pack_sizes: [],
        flavors: []
      })
      this.record.prescription_info.prescription.drugs = drugs
    },
    removeDrug (id) {
      let newDrugs = this.record.prescription_info.prescription.drugs
      newDrugs.splice(id, 1)
      this.record.prescription_info.prescription.drugs = newDrugs
    },
    editPrescription () {
      this.$v.$touch()
      if (!this.$v.record.prescription_info.prescription.drugs.$invalid) {
        this.$refs.prescription_info.close()
      }
    },
    editShippingAndBillingInfo () {
      this.new_shipping_billing_info = JSON.parse(
        JSON.stringify(this.record.prescription_info.shipping_and_billing)
      )
      this.$refs.shipping_billing_info.open()
    },
    cancelEditShippingBilling () {
      this.new_shipping_billing_info = {}
      this.$refs.shipping_billing_info.close()
    },
    editShippingBilling () {
      if (Object.keys(this.new_shipping_billing_info).length !== 0) {
        this.record.prescription_info.shipping_and_billing = JSON.parse(
          JSON.stringify(this.new_shipping_billing_info)
        )
      }
      this.new_shipping_billing_info = {}
      this.$refs.shipping_billing_info.close()
    },
    editAdditionalInfo () {
      this.new_additional_info = JSON.parse(
        JSON.stringify(this.record.prescription_info.additional)
      )
      this.$refs.additional_info.open()
    },
    cancelEditAdditional () {
      this.new_additional_info = {}
      this.$refs.additional_info.close()
    },
    editAdditional () {
      if (Object.keys(this.new_additional_info).length !== 0) {
        this.record.prescription_info.additional = JSON.parse(
          JSON.stringify(this.new_additional_info)
        )
      }
      this.new_additional_info = {}
      this.$refs.additional_info.close()
    }
  }
}
</script>

<style>
.v-autocomplete-list {
  position: absolute;
  top: 47px;
  left: 0;
  right: 0;
  min-width: 100%;
  max-height: 152px;
  background: #fff;
  overflow: auto;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  border: 1px solid #e8e8e8;
  -webkit-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
  z-index: 999;
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.v-autocomplete-list-item {
  position: relative;
  display: block;
  padding: 10px 20px;
  font-weight: 400;
  color: #3c3c3c;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 9;
}
</style>
